import * as Yup from "yup";

const normalizeNumber = (value, originalValue) => {
  if (originalValue === "" || originalValue === null) return undefined;
  if (typeof originalValue === "number" && Number.isNaN(originalValue))
    return undefined;
  return value;
};

export const yupNumber = () => Yup.number().transform(normalizeNumber);
